module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/vegetarian@2x__5fac00a494ef4c35eec913aac4710f29.png";